import React from "react";
import style from "./AboutAuthor.module.scss";
import Image from "next/image";
import Link from "next/link";
import { AboutAuthorType } from "@/components/page-modules/blog/data/blog.types";
import cn from "classnames";
const AboutAuthor: React.FC<AboutAuthorType> = ({
  authorData,
  isWithinBlogPage
}) => {
  const {
    image,
    name,
    title,
    description,
    slug: id
  } = authorData ?? {};
  const titleClassName = isWithinBlogPage ? style.green : "";
  return <div className={style.wrap} data-sentry-component="AboutAuthor" data-sentry-source-file="AboutAuthor.tsx">
      <img src={"/home-page/author-corner.svg"} alt="corner" className={style.corner_top} />
      <img src={"/home-page/author-corner.svg"} alt="corner" className={style.corner_bottom} />
      <div className={style.wrap__flex}>
        {image && <Link href={`/author/${id}`} className={style.img_wrap}>
            <Image src={image} width={173} height={173} alt="author image" />
          </Link>}
        <div className={style.text_wrap}>
          <p className={style.subtitle}>{title ?? ""}</p>
          <Link href={`/author/${id}`} data-sentry-element="Link" data-sentry-source-file="AboutAuthor.tsx">
            <h1 className={cn(style.name, titleClassName)}>{name ?? ""}</h1>
          </Link>
          <p className={style.text} dangerouslySetInnerHTML={{
          __html: description ?? ""
        }}></p>
        </div>
      </div>
    </div>;
};
export default AboutAuthor;